/*
* Kodiert das + Zeichen als %2B, sodass es als URL-Parameter nicht als Leerzeichen interpretiert wird.
* Verwendung: new HttpParams({encoder: new CustomQueryEncoder()})
* See: https://github.com/angular/angular/issues/11058
*/
import { HttpUrlEncodingCodec } from '@angular/common/http';

export class CustomHttpParameterEncoder extends HttpUrlEncodingCodec {

    private static plus: RegExp = /\+/gi;
    private static encodedPlus: string = '%2B';

    encodeKey(k: string): string {
        return this.encode(super.encodeKey(k));
    }

    encodeValue(v: string): string {
        return this.encode(super.encodeValue(v));
    }

    private encode(s: string): string {
        return s.replace(CustomHttpParameterEncoder.plus, CustomHttpParameterEncoder.encodedPlus);
    }
}
